/**
 * The credits-and-slots screen's own routes and nav entry (Figma `185:5432`).
 *
 * `../routes/index.ts` discovers a feature area by globbing for a
 * `routes.ts` one directory below `src/app`, so this file -- one directory
 * further in -- is invisible to it on its own; `../routes.ts` imports it and
 * folds `CAPACITY_ROUTES`/`CAPACITY_NAV` into the tenant area's own bundle,
 * which is what the glob does find.
 */
import { createElement } from 'react';
import { Coins } from 'lucide-react';

import type { NavEntry, RouteModule, RouteRedirect } from '../../routes/contract';
import { Capacity } from './Capacity';
import { cm } from './messages';

const CAPACITY_PATH = '/t/$tenantId/creditos';

export const CAPACITY_ROUTES: RouteModule[] = [
  {
    path: CAPACITY_PATH,
    element: createElement(Capacity),
    requires: 'control_plane.read',
    kind: 'data',
  },
];

/** The retired `/creditos/pedir` page: old links land on Créditos with the dialog open. */
export const CAPACITY_REDIRECTS: RouteRedirect[] = [
  { from: '/t/$tenantId/creditos/pedir', to: CAPACITY_PATH, search: { pedir: 'creditos' } },
];

export const CAPACITY_NAV: NavEntry[] = [
  {
    path: CAPACITY_PATH,
    label: () => cm('page.title'),
    // Hidden from a read-only caller (platform design §17.15); the route
    // above stays open to read, since the API is what refuses the write.
    requires: 'control_plane.write',
    icon: Coins,
    order: 30,
    kind: 'data',
  },
];
